/**
 * ModalidadeTemplate — catálogo global de planos comerciais (Free/Básico/Plus/Pro/Premium),
 * restrito ao tenant principal (ver especificacoes/05-Modalidades-Cotas-Links-IA.md).
 */
import React, { Component } from 'react';
import { TabPanel } from 'primereact/tabview';

import { TabViewComErro } from 'hay-core-react';
import { EntityGrid } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelInputNumber } from 'hay-core-react';
import { ModelBoolean } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import Modalidade from '../../../models/Modalidade';

const model = {
  nome: { exibir: 'main.modalidade.nome', visivel: true, validacao: { obrigatorio: true } },
  slug: { exibir: 'main.modalidade.slug', visivel: true, validacao: { obrigatorio: true } },
  descricao: { exibir: 'main.modalidade.descricao' },
  valor: { exibir: 'main.modalidade.valor', visivel: true, tipo: 'numeric', keyfilter: 'num', validacao: { obrigatorio: true } },
  custo: { exibir: 'main.modalidade.custo', tipo: 'numeric', keyfilter: 'num', validacao: { obrigatorio: true } },
  limitemensallink: { exibir: 'main.modalidade.limitemensallink', visivel: true, tipo: 'numeric', keyfilter: 'num', validacao: { obrigatorio: true } },
  limitemensalassistente: { exibir: 'main.modalidade.limitemensalassistente', visivel: true, tipo: 'numeric', keyfilter: 'num', validacao: { obrigatorio: true } },
  limitefinallink: { exibir: 'main.modalidade.limitefinallink', tipo: 'numeric', keyfilter: 'num' },
  limitefinalassistente: { exibir: 'main.modalidade.limitefinalassistente', tipo: 'numeric', keyfilter: 'num' },
  precoexcedentelink: { exibir: 'main.modalidade.precoexcedentelink', tipo: 'numeric', keyfilter: 'num' },
  precoexcedenteassistente: { exibir: 'main.modalidade.precoexcedenteassistente', tipo: 'numeric', keyfilter: 'num' },
  ordemexibicao: { exibir: 'main.modalidade.ordemexibicao', visivel: true, tipo: 'numeric', keyfilter: 'num' },
  ativo: { exibir: 'main.modalidade.ativo', visivel: true, tipo: 'boolean' },
};

class ModalidadeFormulario extends Component {
  render() {
    const { model, contexto } = this.props;
    return (
      <TabViewComErro tentativaSalvar={contexto.state.tentativaSalvar} className="col-12 mt-2">
        <TabPanel header={UtilService.traduzir('main.modalidade.aba.informacoesbasicas')} leftIcon="pi pi-info-circle mr-2">
          <div className="grid w-full">
            <div className="field col-12 md:col-6 mt-3"><ModelTextInput model={model.nome} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelTextInput model={model.slug} contexto={contexto} /></div>
            <div className="field col-12 mt-3"><ModelTextInput model={model.descricao} contexto={contexto} /></div>
            <div className="field col-12 md:col-4 mt-3"><ModelInputNumber model={model.valor} contexto={contexto} /></div>
            <div className="field col-12 md:col-4 mt-3"><ModelInputNumber model={model.custo} contexto={contexto} /></div>
            <div className="field col-12 md:col-4 mt-3"><ModelInputNumber model={model.ordemexibicao} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelInputNumber model={model.limitemensallink} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelInputNumber model={model.limitemensalassistente} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelInputNumber model={model.limitefinallink} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelInputNumber model={model.limitefinalassistente} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelInputNumber model={model.precoexcedentelink} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelInputNumber model={model.precoexcedenteassistente} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelBoolean model={model.ativo} contexto={contexto} /></div>
          </div>
        </TabPanel>
      </TabViewComErro>
    );
  }
}

class ModalidadeTemplate extends Component {
  render() {
    return (
      <EntityGrid
        entidade={Modalidade}
        model={model}
        identidade="main.modalidade"
        permissoes={this.props.permissoes}
        icone="pi-wallet"
        storageKey="dt-modalidades"
        configuracao={this.props.configuracao}
        navigate={this.props.navigate}
        location={this.props.location}
        searchparams={this.props.searchparams}
        formulario={(m, ctx) => <ModalidadeFormulario model={m} contexto={ctx} />}
      />
    );
  }
}

export default ModalidadeTemplate;
